import React, { FC } from 'react';
import { SurveyTemplatesListPage } from './survey-templates-list.page';

export const SurveyTemplateListAdminLevelPage: FC = () => <SurveyTemplatesListPage isAdminRoute={true} />;
